export const PRIMARY_NOTE_FOREGROUND_COLOR = '#000000';

const emptyEditorStructurePattern =
  /<\/?(?:p|br|ul|ol|li|h[1-6]|blockquote|pre|code)(?:\s[^<>]*)?\/?>/gi;

/** Only known editor structure is empty; formulas and unknown tags are content. */
export const isEmptyCalendarNoteContent = (
  note: string | null | undefined,
  foregroundColor: string | null = PRIMARY_NOTE_FOREGROUND_COLOR,
): boolean => {
  if (note == null || note === '') {
    return true;
  }

  // Secondary notes are plain text, including literal HTML tags and entities.
  if (foregroundColor !== PRIMARY_NOTE_FOREGROUND_COLOR) {
    return note.trim().length === 0;
  }

  return (
    note
      .replace(emptyEditorStructurePattern, '')
      .replace(/&nbsp;/gi, ' ')
      .replace(/\u00a0/g, ' ')
      .trim().length === 0
  );
};

/** Normalizes empty editor HTML while preserving non-empty content verbatim. */
export const normalizeCalendarNoteContent = (note: string): string =>
  isEmptyCalendarNoteContent(note) ? '' : note;
